import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useApplicationType } from '../common/hooks/use-application-type';

/**
 * Whether the sensor feature is on for this client: the `sensorsEnabled` flag, in CAD.
 *
 * Every place the feature hooks into the rest of the app gates on this, so that with it off the
 * app behaves as it did before the feature existed. First Responder is always off: its clients
 * never load sensor data (`SensorsProvider`) and have no workspace window for sensor panels.
 *
 * The two static gates cannot call a hook and read the flag alone: the Sensor Events tab
 * (`event-panel-tabs-config.ts`, CAD-only) and the sensor panel types (`panel-configuration.ts`,
 * which only open in a CAD workspace window).
 */
export function useSensorsEnabled(): boolean {
    const { sensorsEnabled } = useEnabledFeatures();
    const { isCad } = useApplicationType();
    return !!sensorsEnabled && isCad;
}
